import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingConceptDrug,
    getConceptDrugById,
    saveConceptDrug,
    deleteConceptDrug
} from 'app/services/ConceptDrugService';
import { ConceptDrug } from "app/common/Model/ConceptDrug";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";

export default class ConceptDrugStore {

    listAllConceptDrug = [];
    searchConceptDrug = new SearchObject();
    pageConceptDrug = null;
    selectedConceptDrug = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;
    openSyncStore=false

    constructor() {
        makeAutoObservable(this);
    }
    getAllConceptDrug = async (unitType) => {
        if (this.listAllConceptDrug?.length === 0 || this.recentlyUpdated) {
            const searchObjectForAll = {
                pageSize: 1000000,
                pageIndex: 1,
                unitType: unitType,
            };

            pagingConceptDrug(searchObjectForAll)
                .then(({ data }) => {
                    this.listAllConceptDrug = data?.content;
                    this.recentlyUpdated = false;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu thuốc có lỗi")
                })
        }
    }
    

    pagingConceptDrug = async () => {
        return await pagingConceptDrug(this.searchConceptDrug)
            .then(({ data }) => {
                this.pageConceptDrug = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi")
            })
    }

    handleChangeFormSearch = (searchConceptDrug) => {
        this.searchConceptDrug = checkSearchObject(this.searchConceptDrug, searchConceptDrug);
        this.pagingConceptDrug();
    }

    handleOpenFormCreateOrEdit = (drugInteractionsId) => {
        if (Boolean(drugInteractionsId)) {
            getConceptDrugById(drugInteractionsId).then(({ data }) => {
                this.selectedConceptDrug = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedConceptDrug = new ConceptDrug();
            this.openFormCreateOrEdit = true;
        }
    }

    saveConceptDrug = async (drugInteractions, { setSubmitting }) => {
        try {
          const { data } = await saveConceptDrug(drugInteractions);
          if (data) {
            this.selectedConceptDrug = null;
            this.pagingConceptDrug();
            this.handleClosePopup();
            this.recentlyUpdated = true;
    
            toast.success("Lưu bản ghi thành công!");
          }
        } catch {
          toast.error("Lưu bản ghi thất bại!");
        } finally {
          setSubmitting(false);
        }
      };

    handleDelete = (drugInteractions) => {
        this.selectedConceptDrug = { id: drugInteractions?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteConceptDrug(this.selectedConceptDrug?.id)
            .then(() => {
                if (this.searchConceptDrug?.pageIndex > 1 && this.pageConceptDrug?.content?.length === 1) {
                    this.searchConceptDrug.pageIndex -= 1;
                }
                toast.success("Xóa bản ghi thành công!");
                this.handleClosePopup();
                this.pagingConceptDrug();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa bản ghi có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchConceptDrug = new SearchObject();
        this.pageConceptDrug = null;
        this.selectedConceptDrug = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }
}